"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = exports.resetNewPackages = exports.getWorkgroupPackages = exports.getNewPackages = exports.confirmDismissNewPackage = exports.confirmDismissAllPackages = exports.checkNewPackageTransferStatus = exports.archivePackageByPackage = exports.archivePackage = exports.updateTotalCount = exports.getNewPackagesSuccess = exports.updateTotalSearchCount = exports.updateSort = exports.setPackageUpdating = exports.setPackageTransferStatus = exports.setIsSearching = exports.setIncludeHeldNewPackages = exports.saveWorkgroupEmail = exports.resettingNewPackages = exports.resetSort = exports.removeReadPackages = exports.removeReadPackage = exports.markPackageAsArchived = exports.dismissNewPackage = exports.cancelDismissNewPackage = void 0;
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
var models_1 = require("@app/_state/models");
var utils_1 = require("@app/_state/utils");
var selectors_1 = require("@app/features/received-packages/state/selectors");
var selectors_2 = require("@app/features/transfers/state/selectors");
var PackagesApi = __importStar(require("@app/services/api/packages"));
var config_1 = require("@app/shared/config");
var matomo_1 = require("@app/shared/matomo");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.cancelDismissNewPackage = createAction('@@new_packages/CANCEL_DISMISS_NEW_PACKAGE', function (resolve) { return function (packageId) { return resolve(packageId); }; });
exports.dismissNewPackage = createAction('@@new_packages/DISMISS_NEW_PACKAGE', function (resolve) { return function (title, creationDate) { return resolve({ title: title, creationDate: creationDate }); }; });
exports.markPackageAsArchived = createAction('@@new_packages/MARK_AS_ARCHIVED', function (resolve) { return function (packageId) { return resolve(packageId); }; });
exports.removeReadPackage = createAction('@@new_packages/REMOVE_READ_PACKAGE', function (resolve) { return function (packageId) { return resolve(packageId); }; });
exports.removeReadPackages = createAction('@@new_packages/REMOVE_READ_PACKAGES', function (resolve) { return function (packageIds) { return resolve(packageIds); }; });
exports.resetSort = createAction('@@new_packages/RESET_SORT');
exports.resettingNewPackages = createAction('@@new_packages/RESETTING_NEW_PACKAGES', function (resolve) { return function (isResetting) { return resolve(isResetting); }; });
exports.saveWorkgroupEmail = createAction('@@new_packages/SAVE_WORKGROUP_EMAIL', function (resolve) { return function (workgroupEmail) { return resolve(workgroupEmail); }; });
exports.setIncludeHeldNewPackages = createAction('@@new_packages/SET_INCLUDE_HELD_NEW_PACKAGES', function (resolve) { return function (includeHeldNewPackages) { return resolve(includeHeldNewPackages); }; });
exports.setIsSearching = createAction('@@new_packages/SET_IS_SEARCHING', function (resolve) { return function (isSearching) { return resolve(isSearching); }; });
exports.setPackageTransferStatus = createAction('@@new_packages/SET_PACKAGE_TRANSFER_STATUS', function (resolve) { return function (packageId, transferStatus) { return resolve({ packageId: packageId, transferStatus: transferStatus }); }; });
exports.setPackageUpdating = createAction('@@new_packages/SET_PACKAGE_UPDATING', function (resolve) { return function (packageId, isUpdating) { return resolve({ packageId: packageId, isUpdating: isUpdating }); }; });
exports.updateSort = createAction('@@new_packages/UPDATE_SORT', function (resolve) { return function (sortKey, sortDirection) { return resolve({ sortKey: sortKey, sortDirection: sortDirection }); }; });
exports.updateTotalSearchCount = createAction('@@new_packages/UPDATE_TOTAL_COUNT', function (resolve) { return function (count) { return resolve(count); }; });
// Refresh Packages
// AOTDEV-423: prefixing these with "@@refresh_packages" (instead of "@@new_packages") to avoid triggering activity -jh
exports.getNewPackagesSuccess = createAction('@@refresh_packages/GET_NEW_PACKAGES_SUCCESS', function (resolve) { return function (packages, appendRows, mergeWithExisting, viewingWorkgroup, hideArchivedPkgs) {
    return resolve({ packages: packages, appendRows: appendRows, mergeWithExisting: mergeWithExisting, viewingWorkgroup: viewingWorkgroup, hideArchivedPkgs: hideArchivedPkgs });
}; });
exports.updateTotalCount = createAction('@@refresh_packages/UPDATE_TOTAL_COUNT', function (resolve) { return function (totalCount, updateSearchTotal) { return resolve({ totalCount: totalCount, updateSearchTotal: updateSearchTotal }); }; });
/* Action Creators - end */
/* New Packages' Action Functions - begin */
var archivePackage = function (title, creationDate, requestId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, packageId, pkg;
        return __generator(this, function (_a) {
            state = getState();
            if (requestId) {
                // Get packageId from transfers using requestId
                packageId = selectors_2.getPackageIdForActiveXfer(state, requestId);
            }
            if (!packageId) {
                // Get package from state using creationDate
                pkg = selectors_1.getPackageFromCreationDate(state, creationDate);
                if (pkg) {
                    // Set packageId
                    packageId = pkg.id;
                }
            }
            else {
                // Get package from state using packageId
                pkg = selectors_1.getPackageFromPackageId(state, packageId);
            }
            dispatch(exports.archivePackageByPackage(packageId, pkg));
            return [2 /*return*/];
        });
    }); };
};
exports.archivePackage = archivePackage;
var archivePackageByPackage = function (packageId, pkg) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(packageId && pkg && !pkg.archived)) return [3 /*break*/, 2];
                    return [4 /*yield*/, PackagesApi.markPackageAsRead(packageId)];
                case 1:
                    _a.sent();
                    dispatch(exports.markPackageAsArchived(packageId));
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
};
exports.archivePackageByPackage = archivePackageByPackage;
var checkNewPackageTransferStatus = function (packageId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, transferStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.setPackageUpdating(packageId, true));
                    return [4 /*yield*/, PackagesApi.checkPackageTransferStatus(packageId)];
                case 1:
                    transferStatus = _a.sent();
                    if (transferStatus.stop_time === null) {
                        transferStatus.stop_time = moment_1.default(moment_1.default.now()).utc().format();
                    }
                    dispatch(exports.setPackageTransferStatus(packageId, transferStatus));
                    dispatch(exports.setPackageUpdating(packageId, false));
                    if (!(transferStatus.status.toLowerCase() === 'completed')) return [3 /*break*/, 3];
                    return [4 /*yield*/, exports.getWorkgroupPackages(0, config_1.Config.DEFAULT_PAGE_SIZE, state.newPackages.savedWorkgroupEmail, state.packageDetails.savedSearchTerm, false)(dispatch, getState)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.checkNewPackageTransferStatus = checkNewPackageTransferStatus;
var confirmDismissAllPackages = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, packageIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.setIsSearching(true));
                    packageIds = [];
                    return [4 /*yield*/, Promise.resolve(state.newPackages.packages.map(function (pkg) {
                            packageIds.push(pkg.id);
                        }))];
                case 1:
                    _a.sent();
                    new matomo_1.MatomoTracker().trackEvent('New Packages', 'Dismiss All Packages', packageIds.toString());
                    return [4 /*yield*/, PackagesApi.markPackagesAsRead(packageIds)];
                case 2:
                    _a.sent();
                    dispatch(exports.removeReadPackages(packageIds));
                    dispatch(exports.setIsSearching(false));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.confirmDismissAllPackages = confirmDismissAllPackages;
var confirmDismissNewPackage = function (packageId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, newPackage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    newPackage = state.newPackages.packages.find(function (p) { return p.id === packageId; });
                    if (!newPackage) return [3 /*break*/, 2];
                    return [4 /*yield*/, PackagesApi.markPackageAsRead(newPackage.id)];
                case 1:
                    _a.sent();
                    dispatch(exports.removeReadPackage(newPackage.id));
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
};
exports.confirmDismissNewPackage = confirmDismissNewPackage;
var getNewPackages = function (offset, pageSize, searchTerm, appendRows, isViewingWorkgroup, mergeWithExisting) {
    if (appendRows === void 0) { appendRows = true; }
    if (isViewingWorkgroup === void 0) { isViewingWorkgroup = false; }
    if (mergeWithExisting === void 0) { mergeWithExisting = false; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, newPackagesSearch, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    newPackagesSearch = {
                        predicates: [{
                                booleanOperator: 'AND',
                                searchTerms: [
                                    {
                                        key: 'archived',
                                        criteria: false
                                    },
                                    {
                                        key: 'mailbox',
                                        criteria: 'inbox'
                                    },
                                    {
                                        key: 'expired',
                                        criteria: false
                                    },
                                    {
                                        key: 'keyword',
                                        criteria: searchTerm
                                    }
                                ]
                            }]
                    };
                    if (pageSize > 0) {
                        dispatch(exports.setIsSearching(true));
                    }
                    return [4 /*yield*/, PackagesApi.searchPackages({
                            includeHeld: state.newPackages.containsHeldPackages,
                            search: newPackagesSearch,
                            paging: {
                                offset: offset,
                                limit: pageSize
                            },
                            sort: {
                                field: state.newPackages.sortKey,
                                order: state.newPackages.sortDirection
                            }
                        })];
                case 1:
                    response = _a.sent();
                    dispatch(exports.saveWorkgroupEmail(''));
                    if (pageSize === 0) {
                        // Update Count
                        dispatch(exports.updateTotalCount(response.filterOptions.totalCount, false));
                    }
                    else {
                        if (!isViewingWorkgroup) {
                            // Update Packages
                            dispatch(exports.getNewPackagesSuccess(utils_1.checkAsperaTransfers(state.transfers.asperaTransfers, response.packages, models_1.PackageView.INBOX), appendRows, mergeWithExisting, false, true));
                        }
                        if (searchTerm === '') {
                            // Update Count
                            dispatch(exports.updateTotalCount(response.filterOptions.totalCount, isViewingWorkgroup ? false : true));
                        }
                        else {
                            dispatch(exports.updateTotalSearchCount(response.filterOptions.totalCount));
                        }
                        dispatch(exports.setIsSearching(false));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getNewPackages = getNewPackages;
/**
 * Search for packages sent to a specific Workgroup/Dropbox
 * @param offset, starting index
 * @param pageSize, number of packages
 * @param workgroupEmail, email for specified Workgroup
 * @param searchTerm, search term (optional)
 * @param appendRows, add to existing packages (optional)
 * @returns packages to the NewPackages state
 */
var getWorkgroupPackages = function (offset, pageSize, workgroupEmail, searchTerm, appendRows) {
    if (appendRows === void 0) { appendRows = true; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, newPackagesSearch, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    newPackagesSearch = {
                        predicates: [{
                                booleanOperator: 'AND',
                                searchTerms: [
                                    {
                                        key: 'expired',
                                        criteria: false
                                    },
                                    {
                                        key: 'keyword',
                                        criteria: searchTerm
                                    },
                                    {
                                        key: 'userEmails',
                                        criteria: [workgroupEmail]
                                    }
                                ]
                            }]
                    };
                    if (pageSize > 0) {
                        dispatch(exports.setIsSearching(true));
                    }
                    return [4 /*yield*/, PackagesApi.searchPackages({
                            includeHeld: true,
                            search: newPackagesSearch,
                            paging: {
                                offset: offset,
                                limit: pageSize
                            },
                            sort: {
                                field: state.newPackages.sortKey,
                                order: state.newPackages.sortDirection
                            },
                            workgroupSearch: true
                        })];
                case 1:
                    response = _a.sent();
                    dispatch(exports.saveWorkgroupEmail(workgroupEmail));
                    if (pageSize === 0) {
                        // Update Count
                        dispatch(exports.updateTotalCount(response.filterOptions.totalCount, false));
                    }
                    else {
                        // Update Packages
                        dispatch(exports.getNewPackagesSuccess(utils_1.checkAsperaTransfers(state.transfers.asperaTransfers, response.packages, models_1.PackageView.INBOX), appendRows, false, true, false));
                        if (searchTerm === '') {
                            // Update Count
                            dispatch(exports.updateTotalSearchCount(response.filterOptions.totalCount));
                        }
                        else {
                            dispatch(exports.updateTotalSearchCount(response.filterOptions.totalCount));
                        }
                        dispatch(exports.setIsSearching(false));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getWorkgroupPackages = getWorkgroupPackages;
var resetNewPackages = function (pageSize, searchTerm, isViewingWorkgroup, mergeWithExisting) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.resettingNewPackages(true));
                    return [4 /*yield*/, exports.getNewPackages(0, (!searchTerm || searchTerm === '') ? pageSize : 0, '', false, isViewingWorkgroup, mergeWithExisting)(dispatch, getState)];
                case 1:
                    _a.sent();
                    dispatch(exports.resettingNewPackages(false));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.resetNewPackages = resetNewPackages;
var sort = function (sortKey, pageSize, searchTerm) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, isViewingWorkgroup, currentSortKey, currentSortDirection, sortDirection;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    isViewingWorkgroup = state.newPackages.viewingWorkgroup;
                    dispatch(exports.setIsSearching(true));
                    currentSortKey = state.newPackages.sortKey;
                    currentSortDirection = state.newPackages.sortDirection;
                    sortDirection = -1;
                    if (sortKey === currentSortKey) {
                        sortDirection = currentSortDirection * -1;
                    }
                    return [4 /*yield*/, Promise.resolve(dispatch(exports.updateSort(sortKey, sortDirection)))];
                case 1:
                    _a.sent();
                    new matomo_1.MatomoTracker().trackEvent('New Packages', 'Sort', sortKey + " - " + ((sortDirection > 0) ? 'ascending' : 'descending'));
                    if (!isViewingWorkgroup) return [3 /*break*/, 3];
                    return [4 /*yield*/, exports.getWorkgroupPackages(0, pageSize, state.newPackages.savedWorkgroupEmail, searchTerm, false)(dispatch, getState)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, exports.getNewPackages(0, pageSize, searchTerm, false, isViewingWorkgroup, state.newPackages.containsArchivedPackages)(dispatch, getState)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.sort = sort;
/* New Packages's Action Functions - end */
